import * as Yup from "yup";
import { FormGroup } from "../../../components/form/models/models";

export const applicationTypeForm: FormGroup = {
  type: "formGroup",
  fields: [
    {
      type: "field",
      key: "applicationCategory",
      fieldType: "dropdown",
      label: "Application Category",
      props: {
        placeholder: "Select an application type",
        options: [
          {
            label: "Complex Medical Needs",
            value: 0,
          },
          {
            label: "Disability (including developmental delay)",
            value: 1,
          },
          {
            label: "Both Complex Medical Needs and Disability (including developmental delay)",
            value: 2,
          },
        ],
      },
      validation: Yup.string().trim().required("A response is required"), // Basic required validation
    },

    {
      type: "field",
      key: "disabilitySubcriteria",
      fieldType: "dropdown",
      label: "Disability sub-criteria",
      props: {
        placeholder: "Select an application type",
        options: [
          {
            label: "N/A",
            value: 0,
          },
          {
            label: "Risk of injury",
            value: 1,
          },

          {
            label: "Restricted capacity for movement",
            value: 2,
          },
          {
            label: "Both risk of injury and restricted capacity for movement",
            value: 3,
          },
        ],
      },
      validation: Yup.string().trim().required("A response is required"), // Basic required validation
    },
    {
      type: "field",
      key: "disabilityType",
      fieldType: "dropdown",
      label: "Disability type",
      props: {
        placeholder: "Select an application type",
        options: [
          {
            label: "N/A",
            value: 0,
          },
          {
            label: "Diagnosed disability",
            value: 1,
          },

          {
            label: "Disability under assessment",
            value: 2,
          },
        ],
      },
      validation: Yup.string().trim().required("A response is required"), // Basic required validation
    },
    {
      type: "field",
      key: "advisory",
      fieldType: "advisory",
      props: {
        type: "fieldadv",
      },
      label: "Record the category under which the kindergarten is applying",
    },
  ],
};
